<script setup lang="ts">
const svg: any = ref({
  malopolskie: {
    icons: [180, 230],
    text: [20, 10],
    name: 'Tor Kraków',
    redirect: '/tor/tor-krakow',
    path: 'M255.378,421.784l-3.408-1.01a3.189,3.189,0,0,0-1.2-.118L219.547,423.5a3.2,3.2,0,0,1-3.431-3.762l7.053-38.242a3.2,3.2,0,0,1,3.836-2.539l18.875,4.2a3.2,3.2,0,0,1,2.328,2.085l11.1,32.448A3.2,3.2,0,0,1,255.378,421.784Z',
    translate: '-47.288 -159.649'
  },
  slaskie: {
    path: 'M218.578,379.057l-6.949,37.7a3.194,3.194,0,0,1-3.141,2.615H200.42a3.193,3.193,0,0,1-2.335-1.013L183.356,402.59a3.2,3.2,0,0,0-1.408-.877l-1.773-.538a3.194,3.194,0,0,1-2.142-3.945l9.908-34.259a3.194,3.194,0,0,1,4.709-1.854l24.428,14.618A3.2,3.2,0,0,1,218.578,379.057Z',
    translate: '-52.323 -161.962'
  },
  opolskie: {
    icons: [100, 190],
    text: [0, 30],
    name: 'Tor Silesia Ring',
    redirect: '/tor/tor-silesia-ring',
    path: 'M183.851,358.059l-11.06,38.228a3.2,3.2,0,0,1-4,2.167L165.3,397.39a3.2,3.2,0,0,1-2.211-3.629l1.423-7.81a3.2,3.2,0,0,0-2.545-3.711l-16.392-3.122a3.194,3.194,0,0,1-2.094-4.858l18.272-28.594a3.193,3.193,0,0,1,4.333-1.02l16.335,9.785A3.2,3.2,0,0,1,183.851,358.059Z',
    translate: '-56.924 -164.055'
  },
  dolnoslaskie: {
    icons: [30, 160],
    text: [0, -5],
    name: 'Tor Krzywa',
    redirect: '/tor/tor-krzywa',
    path: 'M159.54,344.242,134.06,384.125a3.2,3.2,0,0,1-4.689.774l-1.692-1.355a3.2,3.2,0,0,1-.922-3.791l3.036-6.83a3.193,3.193,0,0,0-1.834-4.3L88.251,354.277a3.2,3.2,0,0,1-2.109-3v-9.4a3.193,3.193,0,0,1,1.73-2.839l29.822-15.381a3.19,3.19,0,0,1,2.715-.1L158.1,339.583A3.194,3.194,0,0,1,159.54,344.242Z',
    translate: '-64.503 -166.964'
  },
  lubuskie: {
    path: 'M88.581,330.061v-1.268a3.21,3.21,0,0,0-.082-.718l-3.443-14.911a3.213,3.213,0,0,1-.081-.719V288.482a3.2,3.2,0,0,0-1.1-2.414l-15.827-13.71a3.2,3.2,0,0,1-1.1-2.414v-.086h38.39a3.2,3.2,0,0,1,3.16,2.727l6.88,46.461a3.2,3.2,0,0,1-1.7,3.308L93.24,332.9A3.194,3.194,0,0,1,88.581,330.061Z',
    translate: '-66.942 -174.03'
  },
  lodzkie: {
    icons: [140, 150],
    text: [0, 30],
    name: 'Tor Łódź',
    redirect: '/tor/tor-lodz',
    path: 'M230.629,345.212l-24.023,17.844a3.2,3.2,0,0,1-3.546.177l-34.419-20.6a3.194,3.194,0,0,1-1.052-4.461l27.586-43.184a3.194,3.194,0,0,1,3.658-1.325l23.611,7.483a3.2,3.2,0,0,1,2.174,2.455l7.244,38.456A3.194,3.194,0,0,1,230.629,345.212Z',
    translate: '-53.697 -170.881'
  },
  swietokrzyskie: {
    icons: [180, 185],
    text: [20, 10],
    name: 'Tor Kielce',
    redirect: '/tor/tor-kielce-miedziana-gora',
    path: 'M262.012,358.052l-11.1,17.751a3.2,3.2,0,0,1-3.4,1.426l-24.373-5.416a3.206,3.206,0,0,1-.948-.378l-9.386-5.619a3.2,3.2,0,0,1-.264-5.306l19.343-14.372a3.2,3.2,0,0,1,2.824-.5l25.513,7.657A3.193,3.193,0,0,1,262.012,358.052Z',
    translate: '-47.899 -164.132'
  },
  podkarpackie: {
    path: 'M289.115,413.74l2.911,18.155a3.194,3.194,0,0,1-4.059,3.569L270.158,430.2a3.2,3.2,0,0,1-2.117-2.03l-15.124-44.21a3.193,3.193,0,0,1,.314-2.727l13.709-21.925a3.194,3.194,0,0,1,4.248-1.106l45.285,24.909a3.2,3.2,0,0,1,.512,5.249l-26.768,22.423A3.2,3.2,0,0,0,289.115,413.74Z',
    translate: '-42.3 -162.325'
  },
  lubelskie: {
    icons: [250, 160],
    text: [-45, 15],
    name: 'Tor Ułęż',
    redirect: '/tor/tor-ulez',
    path: 'M328.969,383.568l-.566.476a3.2,3.2,0,0,1-3.593.352l-53.173-29.242a3.194,3.194,0,0,1-1.649-3L272.179,318a3.2,3.2,0,0,1,1.907-2.722l29.441-12.9a3.2,3.2,0,0,1,2.883.162l14.163,8.2a3.194,3.194,0,0,1,1.54,3.346L317.074,341.3a3.194,3.194,0,0,0,.119,1.617l12.744,37.164A3.2,3.2,0,0,1,328.969,383.568Z',
    translate: '-40.11 -169.699'
  },
  podlaskie: {
    icons: [250, 70],
    text: [-50, -5],
    name: 'Tor Białystok',
    redirect: '/tor/tor-bialystok',
    path: 'M325.821,288.812l-16.092,10.5a3.194,3.194,0,0,1-4.348-.824l-38.963-54.748a3.194,3.194,0,0,1,1.373-4.8l23.779-9.914a3.194,3.194,0,0,0,1.965-2.948V212.183a3.194,3.194,0,0,1,3.194-3.2h9.254a3.2,3.2,0,0,1,3.1,2.435l18.093,73.953A3.2,3.2,0,0,1,325.821,288.812Z',
    translate: '-40.638 -182.21'
  },
  mazowieckie: {
    icons: [200, 140],
    text: [20, 15],
    name: 'Tor Jastrząb',
    redirect: '/tor/tor-jastrzab-radom',
    path: 'M302.9,303.236,273.28,316.207a3.2,3.2,0,0,0-1.907,2.722l-2.255,35.184a3.194,3.194,0,0,1-4.107,2.855l-25.079-7.527a3.2,3.2,0,0,1-2.221-2.468l-8.393-44.562a3.192,3.192,0,0,0-2.174-2.454l-25.169-7.971a3.194,3.194,0,0,1-1.728-4.765l17.495-27.4a3.193,3.193,0,0,1,1.464-1.229l41.33-17.22a3.193,3.193,0,0,1,3.831,1.1l39.858,55.985A3.194,3.194,0,0,1,302.9,303.236Z',
    translate: '-49.031 -177.731'
  },
  mazowieckie2: {
    icons: [200, 90],
    text: [20, 10],
    name: 'Tor Modlin',
    redirect: '/tor/tor-modlin'
  },
  mazowieckie3: {
    icons: [190, 120],
    text: [20, 15],
    name: 'Tor Słomczyn',
    redirect: '/tor/tor-slomczyn'
  },
  warminsko_mazurskie: {
    path: 'M290.984,212.183v7.129a3.193,3.193,0,0,1-1.967,2.948L218.9,251.488a3.2,3.2,0,0,1-4.016-1.387l-8.435-15.049a3.183,3.183,0,0,1-.408-1.562V212.183a3.194,3.194,0,0,1,3.194-3.2h78.554A3.2,3.2,0,0,1,290.984,212.183Z',
    translate: '-48.473 -182.21'
  },
  kujawsko_pomorskie: {
    icons: [120, 70],
    text: [20, 10],
    name: 'Tor Toruń',
    redirect: '/tor/tor-torun',
    path: 'M214.478,256.847l-26.82,41.993a3.2,3.2,0,0,1-5.148.325l-30.381-36.494a3.2,3.2,0,0,1-.691-1.491l-3.292-18.744a3.194,3.194,0,0,1,3.059-3.746l52.266-1.425a3.192,3.192,0,0,1,2.873,1.631l8.229,14.668A3.2,3.2,0,0,1,214.478,256.847Z',
    translate: '-56.205 -178.343'
  },
  wielkopolskie: {
    icons: [70, 110],
    text: [0, 30],
    name: 'Tor Poznań',
    redirect: '/tor/tor-poznan',
    path: 'M182.857,312.467l-17.608,27.579a3.2,3.2,0,0,1-3.943,1.221l-39.559-16.825a3.192,3.192,0,0,1-1.909-2.472l-7.49-50.563a3.2,3.2,0,0,1,1.008-2.83L138.2,245.934a3.2,3.2,0,0,1,5.3,1.809l2.962,16.86a3.2,3.2,0,0,0,.691,1.491l35.469,42.61A3.2,3.2,0,0,1,182.857,312.467Z',
    translate: '-60.935 -177.246'
  },
  wielkopolskie2: {
    icons: [80, 100],
    text: [20, 10],
    name: 'Tor Bednary',
    redirect: '/tor/tor-bednary'
  },
  zachodniopomorskie: {
    icons: [50, 40],
    text: [20, 10],
    path: 'M144.436,237.177l-33.648,30.656a3.192,3.192,0,0,1-2.151.833H73.659a3.2,3.2,0,0,1-2.708-4.889l1.119-1.788a3.188,3.188,0,0,0,.474-1.972L70.611,237.83a3.192,3.192,0,0,1,1.986-3.239l51.384-20.764a3.2,3.2,0,0,0,1.5-1.248l7.176-11.284a3.2,3.2,0,0,1,1.668-1.311l1.277-.433a3.193,3.193,0,0,1,4.174,2.473l5.656,32.239A3.191,3.191,0,0,1,144.436,237.177Z',
    translate: '-66.495 -183.43',
    name: 'Tor Koszalin',
    redirect: '/tor/tor-koszalin'
  },
  pomorskie: {
    icons: [95, 20],
    text: [20, 10],
    name: 'Tor Pszczółki',
    redirect: '/tor/tor-pszczolki',
    path: 'M204.237,215.2v15.414a3.2,3.2,0,0,1-3.107,3.194l-51.659,1.417a3.194,3.194,0,0,1-3.235-2.641l-5.8-33.04a3.194,3.194,0,0,1,2.119-3.577L173.665,185.4a3.2,3.2,0,0,1,4.223,3.025v20.386a3.194,3.194,0,0,0,3.194,3.194h19.96A3.2,3.2,0,0,1,204.237,215.2Z',
    translate: '-57.23 -185.228'
  }
})
const mapRedirect = async (id: number) => await navigateTo(svg.value[id].redirect)
const getName = (name: string) => tor(name)
</script>

<template>
  <div class="flex flex-col sm:absolute sm:w-2/5 top-0 right-0 bg-secondary h-full p-[20px]">
    <div class="text-24 lg:text-30 font-medium text-white">
      Wybierz tor
    </div>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 290 273.273"
      preserveAspectRatio="xMinYMin meet"
    >
      <g
        v-for="(el, index) in svg"
        :key="index"
      >
        <a :href="el.redirect" :title="getName(el.name)" :aria-label="getName(el.name)" @click.prevent="mapRedirect(index)">
          <path v-if="el.path" :d="el.path" :transform="`translate(${el.translate})`" fill="#fff" opacity="0.4" />
          <g v-if="el.icons" :transform="`translate(${el.icons[0]} ${el.icons[1]})`" class="cursor-pointer" @click="mapRedirect(index)">
            <path d="M512 0c-176.732 0-320 143.268-320 320 0 320 320 704 320 704s320-384 320-704c0-176.732-143.27-320-320-320zM512 512c-106.040 0-192-85.96-192-192s85.96-192 192-192 192 85.96 192 192-85.96 192-192 192z" :x="el.icons[0]" :y="el.icons[1]" transform="scale(0.02 0.02)" class="fill-primary" />
            <text v-html="el.name" :x="el.text[0]" :y="el.text[1]" class="text-10 fill-white" />
          </g>
        </a>
      </g>
    </svg>
  </div>
</template>
